import type { LoaderFunction, MetaFunction } from 'react-router';

import { createMeta } from '~/utils/application'
import SearchPage, {
  loader as searchPageLoader,
} from './_user.search.$keywords'

export const meta: MetaFunction = args => createMeta({
  ...args,
  title: "検索ページ",
  isShortedTitle: false,
})

export const loader: LoaderFunction = searchPageLoader

export default SearchPage
